<template>
    <vue-simple-spinner
        :line-fg-color="colour"
        :size="size"
    />
</template>

<script>
import Spinner from 'vue-simple-spinner';

export default {

    components: {
        'vue-simple-spinner': Spinner,
    },

    props: {
        size: {
            type: String,
            default: '28',
        },
        variant: {
            type: String,
            default: null,
        },
    },

    computed: {
        colour() {
            if (this.variant === 'success') {
                return '#1c84c6';
            }
            if (this.variant === 'danger') {
                return '#ED5565';
            }
            // Return primary colour by default.
            return '#18a689';
        },
    },

};
</script>
